module.exports = __webpack_public_path__ + "img/yq-l.719d238f.png";